const subMenuMobile = () => {
    const dropdown  = document.querySelector('.js-sub-menu-dropdown');

    if ( dropdown ) {
        dropdown.addEventListener('change', (e) => {
            const url = e.target.value;

            window.location = url;
        });
    }
}   

subMenuMobile();